import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from '@chakra-ui/react';

import MessageTable from './components/MessageTable';
import MessageCampaigns from './campaigns/MessageCampaigns';
import { WhatsAppTemplatesProvider } from './context/WhatsAppTemplatesContext';

export default function Messaging() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <WhatsAppTemplatesProvider>
        <Tabs align="start" variant="enclosed" isLazy lazyBehavior="keepMounted">
          <TabList>
            <Tab>הודעות</Tab>
            <Tab>קמפיינים</Tab>
          </TabList>
          <TabPanels>
            <TabPanel px={0}>
              <MessageTable />
            </TabPanel>
            <TabPanel px={0}>
              <MessageCampaigns />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </WhatsAppTemplatesProvider>
    </Box>
  );
}
